// @flow

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';

import 'app/viewport/components/Header/HeaderLogo.scss';

import type { KindType } from 'app/common/types';

const bem = bemify('header-logo');

type Props = {
  target?: '_blank' | '_self',
  kind?: KindType,
  isLoggedIn?: boolean,
};

const HeaderLogo = ({ target = '_self', kind, isLoggedIn }: Props) => (
  // eslint-disable-next-line jsx-a11y/anchor-has-content
  <a
    className={bem(
      isLoggedIn ? '--logged-in' : '--logged-out',
      toModifiers(kind)
    )}
    href="/"
    target={target}
    title="Go to the Zapier Homepage"
  />
);

export default HeaderLogo;
